export default function (vue) {
    // Common
    vue.component('container', require('./Common/Container.vue').default);
    vue.component('settings-container', require('./Common/SettingsContainer.vue').default);
    vue.component('spinner', require('./Common/Spinner.vue').default);
    vue.component('toggle-switch', require('./Common/ToggleSwitch.vue').default);
    vue.component('windows', require('./Common/Windows.vue').default);
    vue.component('window', require('./Common/Windows/Window.vue').default);
    vue.component('window-data', require('./Common/Windows/WindowData.vue').default);
    vue.component('popups', require('./Common/Popups.vue').default);
    vue.component('popup', require('./Common/Popups/Popup.vue').default);
    vue.component('popover', require('./Common/Popover.vue').default);
    vue.component('collapsible', require('./Common/Collapsible.vue').default);
    vue.component('editable', require('./Common/Editable.vue').default);
    vue.component('editable-input', require('./Common/Editable/Input.vue').default);
    vue.component('editable-text', require('./Common/Editable/Text.vue').default);
    vue.component('editable-image', require('./Common/Editable/Image.vue').default);
    vue.component('editable-check', require('./Common/Editable/Check.vue').default);
    vue.component('editable-select', require('./Common/Editable/Select.vue').default);
    vue.component('editable-select-modal', require('./Common/Editable/SelectModal.vue').default);
    vue.component('editable-multi-select', require('./Common/Editable/MultiSelect.vue').default);
    vue.component('editable-multi-select-option', require('./Common/Editable/MultiSelectOption.vue').default);
    vue.component('editable-date', require('./Common/Editable/Date.vue').default);
    vue.component('editable-time', require('./Common/Editable/Time.vue').default);
    vue.component('editable-file', require('./Common/Editable/File.vue').default);
    vue.component('editable-list', require('./Common/Editable/List.vue').default);
    vue.component('editable-group', require('./Common/Editable/Group.vue').default);
    //vue.component('editable-editor', require('./Common/Editable/Editor.vue').default);
    vue.component('editable-tags', require('./Common/Editable/Tags.vue').default);
    vue.component('editable-choose', require('./Common/Editable/Choose.vue').default);
    vue.component('editable-button', require('./Common/Editable/Button.vue').default);
    vue.component('search-field', require('./Common/SearchField.vue').default);
    vue.component('tab-container', require('./Common/TabContainer.vue').default);
    vue.component('tab-container-modal', require('./Common/TabContainerModal.vue').default);
    vue.component('tab-container-icon', require('./Common/TabContainerIcon.vue').default);
    vue.component('list-searchable', require('./Common/ListSearchable.vue').default);
    vue.component('data-container', require('./Common/DataContainer.vue').default);
    vue.component('clone-component', require('./Common/CloneComponent.vue').default);
    vue.component('google-map', require('./Common/Map.vue').default);

    vue.component('autocomplete-address', require('./Common/Editable/GoogleAutoComplete.vue').default);

    // Users
    vue.component('password-strength-meter', require('./Users/PasswordStrengthMeter.vue').default);
    vue.component('notifications', require('./Users/Notifications.vue').default);

    // Jobs
    vue.component('job-list', require('./Jobs/JobList.vue').default);
    vue.component('job-list-item', require('./Jobs/JobListItem.vue').default);
    vue.component('job-list-date-item', require('./Jobs/JobListDateItem.vue').default);
    vue.component('job-calendar', require('./Jobs/JobCalendar.vue').default);
    vue.component('job-rating-display', require('./Jobs/JobRatingDisplay.vue').default);
    vue.component('job-part-pdf', require('./Jobs/JobPartPdf.vue').default);

    // Messages
    vue.component('messages', require('./Messages/Messages.vue').default);

    // Dynamic async components
    vue.component('calendar', require('./Common/Calendar.vue').default);
}

